var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"markdown-span-override is-clearfix",class:{hideElements: _vm.hideElements},domProps:{"innerHTML":_vm._s(_vm.body)},on:{"click":_vm.checkClick}})}
var staticRenderFns = []

export { render, staticRenderFns }